<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <p class="hint">
            Define el porcentaje de leads de Meta que recibe cada empleado activo (administradores y comerciales). La suma debe ser
            exactamente 100%.
          </p>

          @if (loading) {
            <p>Cargando…</p>
          } @else if (rows.length === 0) {
            <p>No hay empleados elegibles.</p>
          } @else {
            <div class="bisual-table" id="lead-assignment-table">
              <div class="bisual-table-row-header">
                <div class="bisual-table-col">Empleado</div>
                <div class="bisual-table-col">Rol</div>
                <div class="bisual-table-col">Leads Meta asignados</div>
                <div class="bisual-table-col pct-col">%</div>
              </div>
              @for (row of rows; track row.user_id) {
                <div class="bisual-table-row">
                  <div class="bisual-table-col">{{ row.name }} {{ row.surnames }}</div>
                  <div class="bisual-table-col">{{ roleLabel(row) }}</div>
                  <div class="bisual-table-col">{{ row.meta_leads_assigned }}</div>
                  <div class="bisual-table-col pct-col">
                    <mat-form-field appearance="outline" class="pct-field" subscriptSizing="dynamic">
                      <input matInput type="number" min="0" max="100" step="0.01" [(ngModel)]="row.percentage" [disabled]="!canEdit" />
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>

            <div class="footer-bar">
              <div class="total" [ngClass]="{ ok: isValidTotal, bad: !isValidTotal }">
                Total: {{ totalPercentage }}%
                @if (!isValidTotal) {
                  <span>(debe ser 100%)</span>
                }
              </div>

              @if (canEdit) {
                <button mat-flat-button color="primary" type="button" [disabled]="!isValidTotal || saving" (click)="save()">
                  <mat-icon>save</mat-icon>
                  Guardar
                </button>
              }
            </div>
          }

          @if (error) {
            <p class="feedback error">{{ error }}</p>
          }
          @if (success) {
            <p class="feedback success">{{ success }}</p>
          }
        </div>
      </div>
    </div>

    @if (historyPeriods.length > 0) {
      <div class="row">
        <div class="col-12">
          <div class="card history-card">
            <h2 class="history-title">Histórico</h2>
            <p class="hint">Periodos de configuración de porcentajes. Al guardar se cierra el vigente y se abre uno nuevo.</p>

            @for (period of historyPeriods; track period.start_date + (period.end_date ?? 'current')) {
              <div class="history-period">
                <div class="history-period-header">
                  <span class="history-badge" [class.current]="period.end_date == null">{{ periodLabel(period) }}</span>
                  <span class="history-dates">
                    {{ period.start_date | date: 'short' }}
                    @if (period.end_date != null) {
                      — {{ period.end_date | date: 'short' }}
                    } @else {
                      — ahora
                    }
                  </span>
                </div>
                <ul class="history-weights">
                  @for (weight of period.weights; track weight.user_id) {
                    <li>
                      <span>{{ weight.name }} {{ weight.surnames }}</span>
                      <strong>{{ weight.percentage }}%</strong>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
